import API from '../../../services/apiService.js'

var api= new API();
export default {

    reset({commit}){
        commit("reset")
    },

    async getNewChats({commit}) {
        let data = null;
        try {
            data = api.Get("Chat/NewChatList");
            commit('loadChats', await data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },
    async getActiveChats({commit}) {
        let data = null;
        try {
            data = api.Get("Chat/CurrentUserChatList");
            commit('loadChats', await data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    async getHistoryChats({commit}) {
        let data = null;
        try {
            data = api.Get("Chat/ArchiveList");
            commit('loadChats', await data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    async getChatMessages({commit}, chatId) {
        let data = null;
        try {
            data = await api.Get(`Chat?ChatId=${chatId}`);
            commit('loadChatMessage', data);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    putMessage({commit}, mesModel) {
        if (mesModel != null) {
            commit("putMessage", mesModel);
        }
    },

    async sendMessage({dispatch, commit}, mesModel) {
        let data = null;
        try {
            data = await api.Post("Chat", mesModel);
            return data;
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    async resetMessageCounter({commit}, chatId) {
        let data = {
            chatId: chatId
        };
        try {
            await api.Post("Chat/ResetMessageCounter", data);
            commit("resetMessageCounter", chatId);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },
    //отправить в архив
    async archive({commit}, model) {
        try {
            let params = `?requestId=${model.requestId}`
            await api.Post("RequestService/Request/Archive", params);
            commit("archiveChat", model.chatId);
        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //принять чат в работу
    async acceptChat({commit}, chatId) {
        try {
            let params = `?ChatId=${chatId}`;
            await api.Post("Chat/AcceptChat" + params);

        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

    //завершить заказ
    async completeChat({commit}, chatId) {
        try {
            let params = `?ChatId=${chatId}`;
            await api.Post("Chat/CloseRequest" + params);

        } catch (e) {
            console.log(e);
            throw new Error(e);
        }
    },

}
